/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

import Vue from "vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import App from "./App.vue";

// used to get scroll position for custom scrolling tables
import vuescroll from "vue-scroll";

// my library for profiling code
import "./profile";

Vue.config.productionTip = false;
window.Vue = Vue;

console.log("Hello");

Vue.component("navbar", require("./components/Navbar").default);
Vue.component("m-form", require("./components/ApiForm.vue").default);
Vue.component("m-checkbox", require("./components/CheckBox.vue").default);
Vue.component("m-combobox", require("./components/ComboBox.vue").default);
Vue.component("m-textinput", require("./components/TextInput.vue").default);
Vue.component("m-datepicker", require("./components/DatePicker.vue").default);
Vue.component("m-textarea", require("./components/TextArea.vue").default);
Vue.component("m-password", require("./components/PasswordInput.vue").default);
Vue.component("m-submit", require("./components/SubmitButton.vue").default);
Vue.component("m-menu", require("./components/Menu.vue").default);
Vue.component("m-menubutton", require("./components/MenuButton.vue").default);
Vue.component("m-item", require("./components/MenuItem.vue").default);
Vue.component("m-graph", require("./components/DyGraph.vue").default);
Vue.component("m-table", require("./components/LogTable.vue").default);
Vue.component("m-autocomplete", require("./components/Autocomplete").default);
Vue.component("m-maxmin", require("./components/LogMaxMin").default);
Vue.component(
    "multi-device-legend",
    require("./components/MultiDeviceLegend").default
);
Vue.component("m-errorbox", require("./components/ErrorBox").default);
Vue.component("olMap", require("./components/Map").default);
Vue.component(
    "h-autocomplete",
    require("./components/HereAutocomplete").default
);
Vue.component("usb-device-list", require("./components/UsbDeviceList").default);
Vue.component("usb-file-list", require("./components/UsbFileList").default);
Vue.component("log-file-list", require("./components/LogFileList").default);
Vue.component("resource-view", require("./components/ResourceView").default);
Vue.component("resource-cards", require("./components/ResourceCards").default);
Vue.component("service-worker", require("./components/ServiceWorker").default);
Vue.component("vue-ip", require("./components/VueIp").default);

// used to get scroll position for custom scrolling tables
Vue.use(vuescroll);

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount("#app");
